import { render, staticRenderFns } from "./KugoAlbumList.vue?vue&type=template&id=4e123502&"
import script from "./KugoAlbumList.vue?vue&type=script&lang=js&"
export * from "./KugoAlbumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports